import Grid from "@mui/material/Grid2";
import { AccordionSection } from "components/FormControls/AcordionSection/AccordionSection";
import { FormSection } from "components/FormControls/FormSection";
import { HelpPanel } from "components/HelpPanel/HelpPanel";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { useState } from "react";
import {
  CampaignLimits as CampaignLimitsType,
  CampaignTriggersUnion,
} from "types/campaigns";
import { useStyles } from "../styles";
import { TriggerBox } from "../Triggers/TriggerBox";
import { Limit } from "./Limit";

export enum Sections {
  LIMIT = "limit",
  BUDGET = "budget",
}

interface Props {
  trigger: CampaignTriggersUnion;
  limits: Partial<CampaignLimitsType>;
  sectionErrors: {
    limit: boolean;
    budget: boolean;
  };
}

export const Limitations = ({ trigger, limits, sectionErrors }: Props) => {
  const [activeSection, setActiveSection] = useState<Sections | false>(
    Sections.LIMIT,
  );
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <Grid container spacing={12}>
      <Grid size={{ xs: 8 }}>
        <FormSection
          title={
            <div className={classes.sectionTitleWrapper}>
              {message({ id: "limmitation&budget" })}
              <TriggerBox />
            </div>
          }
        >
          <AccordionSection
            idx={1}
            sectionId={Sections.LIMIT}
            title="campaignLimit"
            subtitle="focusOnParticipantRestrictions"
            details={
              <>
                <Limit
                  name="executionsPerMember"
                  data-test-id="campaign-limits-executions-per-member"
                  value={limits.executionsPerMember}
                />
                <OLButton
                  className={classes.sectionNextBtn}
                  variant="contained"
                  onClick={() => setActiveSection(Sections.BUDGET)}
                >
                  {`${message({ id: "next" })}: ${message({ id: "campaignBudget" })}`}
                </OLButton>
              </>
            }
            isEditMode={false}
            isExpanded={activeSection === Sections.LIMIT}
            setExpanded={(panel) => setActiveSection(panel as Sections)}
            hasError={sectionErrors.limit}
          />
          <AccordionSection
            idx={2}
            sectionId={Sections.BUDGET}
            title="campaignBudget"
            subtitle="controlsTotalAvailabilityOfCampaignRewards"
            details={
              <Grid container spacing={12}>
                <Grid size={{ xs: 12 }}>
                  <Limit
                    name="points"
                    value={limits.points}
                    data-test-id="campaign-limits-points"
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <Limit
                    name="pointsPerMember"
                    value={limits.pointsPerMember}
                    data-test-id="campaign-limits-points-per-member"
                  />
                </Grid>
              </Grid>
            }
            isEditMode={false}
            isExpanded={activeSection === Sections.BUDGET}
            setExpanded={(panel) => setActiveSection(panel as Sections)}
            hasError={sectionErrors.budget}
          />
        </FormSection>
      </Grid>
      <Grid size={{ xs: 4 }} mt={20}>
        <HelpPanel
          title="limmitation&budget"
          description="limitationAndBudget"
        />
      </Grid>
    </Grid>
  );
};
